import React, { useState } from "react";
import { InputWrapper } from "../components/input";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const ResetPassword = () => {
  const history = useHistory();
  const [state, setState] = useState({
    code: "",
    email: "",
    resetPassword: "",
    confirmPassword: "",
  });

  // const [resetPasswordMutation, { loading }] = useMutation(RESET_PASSWORD);

  // const handleReset = async () => {
  //   try {
  //     await resetPasswordMutation({
  //       variables: {
  //         email: state.email,
  //         code: state.code,
  //         newPassword: state.resetPassword,
  //         reenterPassword: state.confirmPassword,
  //       },
  //     });
  //     history.push("/");
  //   } catch (err) {
  //     setErrorModal({ vis: true, e: err });
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 448,
            height: 512,
            padding: "0 32px",
            backgroundColor: "#fff",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "start",
          }}
        >
          {/* <div
            style={{
              marginBottom: 32,
              position: "relative",
              left: "-190px",
              top: "-36px",
            }}
          >
            <StyledLink to="/forgotpassword">
              <ArrowLeftOutlined /> Back
            </StyledLink>
          </div> */}

          <InputWrapper
            label="Code"
            name="code"
            value={state.code}
            placeholder="845697"
            onChange={handleChange}
          />
          <InputWrapper
            label="Email"
            name="email"
            value={state.email}
            placeholder="abc@xyz.com"
            onChange={handleChange}
          />
          <InputWrapper
            label="New Password"
            name="resetPassword"
            value={state.resetPassword}
            placeholder="Password"
            type={`password`}
            onChange={handleChange}
          />
          <InputWrapper
            label="Confirm Password"
            name="confirmPassword"
            value={state.confirmPassword}
            placeholder="Password"
            type={`password`}
            onChange={handleChange}
          />

          <button
            style={{ marginTop: 32, height: 40 }}
            // loading={loading}
            // onClick={handleReset}
          >
            Reset Password
          </button>
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
